module.exports = __webpack_public_path__ + "static/media/Labels_SleepizOne_20-001-03.df813af4.pdf";